module.exports = __webpack_public_path__ + "img/caret-up-square-fill.e66c9c8d.svg";